<template>
  <main class="tab-content">
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_studios' }]"
      id="admin_studios">
      <Studios :fit20="fit20" :admin="true" :selectTab="selectTab" :admin_fit20="admin_fit20" :formatDate="formatDate">
      </Studios>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_studio' }]"
      id="admin_studio">
      <Studio :fit20="fit20" :admin="true" :selectTab="selectTab" :admin_fit20="admin_fit20" :formatDate="formatDate">
      </Studio>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_machines' }]"
      id="admin_machines">
      <Machines :fit20="fit20" :selectTab="selectTab" :admin_fit20="admin_fit20"></Machines>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_machine' }]"
      id="admin_machine">
      <Machine :fit20="fit20" :selectTab="selectTab" :admin_fit20="admin_fit20"></Machine>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_users' }]" id="admin_users">
      <Users :fit20="fit20" :admin="true" :selectTab="selectTab" :admin_fit20="admin_fit20"></Users>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_user' }]" id="admin_user">
      <User :fit20="fit20" :admin="true" :selectTab="selectTab" :admin_fit20="admin_fit20" :formatDate="formatDate">
      </User>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_members' }]"
      id="admin_members">
      <Members :fit20="fit20" :admin="true" :selectTab="selectTab" :admin_fit20="admin_fit20"></Members>
    </div>
    <div :class="['admin-tab-pane fade', { 'show active': fit20.selectedTabHref == '#admin_member' }]"
      id="admin_member">
      <Member :fit20="fit20" :admin="true" :selectTab="selectTab" :admin_fit20="admin_fit20" :formatDate="formatDate">
      </Member>
    </div>
    <div class="admin-tab-pane fade" id="admin_overviews">
      admin overviews
    </div>

  </main>
</template>

<script>
import Studios from '../Studios.vue';
import Studio from './Studio.vue';
import Machines from "./Machines.vue";
import Machine from "./Machine.vue";
import Members from "../Members.vue";
import Member from './Member.vue';
import Users from './Users.vue';
import User from './User.vue';

export default {
  name: 'Content',
  components: {
    Studios,
    Studio,
    Machines,
    Machine,
    Members,
    Member,
    Users,
    User
  },
  props: ['fit20', "selectTab", "admin_fit20", "formatDate"],
  data() {
    return {
      // currentMembers: [{
      //   id: 45454,
      //   fullName: 'test test',
      // },],
    };
  },
  methods: {

  },
  computed: {
    memberSince: function () { },
  },
};
</script>

<style>
/* .display-none {
  display: none;
} */

.admin-tab-pane {
  display: none;
  position: absolute;
  top: 0;
  left: 25%;
  width: 75%;
  height: 100%;
  overflow: hidden;
}
</style>
